'use strict';

var activateKeyDownAction = function (e) { return e.key === 'Enter' || e.key === ' '; };

exports.activateKeyDownAction = activateKeyDownAction;
